// Sample Request configuration data
// Easy to update as categories and products expand

export const sampleTypes = [
  {
    id: "single-sample",
    label: "Single Sample",
    description: "Order one sample of a specific product",
    icon: "swatch"
  },
  {
    id: "quick-sets",
    label: "Quick Sample Sets",
    description: "Pre-assembled sample chain sets for fast evaluation",
    icon: "swatches"
  },
  {
    id: "category-samples",
    label: "Product Category Samples",
    description: "Samples from a specific product category",
    icon: "grid"
  },
  {
    id: "custom-samples",
    label: "Portico Custom Samples",
    description: "Custom logo mats and branded flooring samples",
    icon: "palette"
  }
];

// Sample formats keyed by sample type
export const sampleFormats = {
  "single-sample": [
    { id: "3x5", label: '3" x 5" Single Sample' },
    { id: "9x9", label: '9" x 9" Single Sample' }
  ],
  "quick-sets": [
    { id: "3x5-chain", label: '3" x 5" Full Sample Chain Set' },
    { id: "9x9-set", label: '9" x 9" Set' }
  ],
  "category-samples": [
    { id: "3x5", label: '3" x 5" Sample' },
    { id: "9x9", label: '9" x 9" Sample' }
  ],
  "custom-samples": [
    { id: "3x5", label: '3" x 5" Sample' },
    { id: "9x9", label: '9" x 9" Sample' }
  ]
};

// Product categories for selection
export const sampleCategories = [
  { id: "broadloom", label: "Roll / Sheet Goods" },
  { id: "carpet-tile", label: "Carpet Tile Goods" },
  { id: "luxury-vinyl", label: "LVP & LVT" },
  { id: "commercial-mats", label: "Commercial Mats" },
  { id: "grid-entry-systems", label: "Grid Entry" },
  { id: "industrial-anti-fatigue", label: "Industrial Anti-Fatigue" },
  { id: "recycle-rubber", label: "Recycled Rubber" },
  { id: "custom-logo-mats", label: "Portico Custom Samples" },
  { id: "non-slip-flooring", label: "Non-Slip Flooring" }
];

// US States for address dropdown
export const usStates = [
  "AL","AK","AZ","AR","CA","CO","CT","DE","FL","GA",
  "HI","ID","IL","IN","IA","KS","KY","LA","ME","MD",
  "MA","MI","MN","MS","MO","MT","NE","NV","NH","NJ",
  "NM","NY","NC","ND","OH","OK","OR","PA","RI","SC",
  "SD","TN","TX","UT","VT","VA","WA","WV","WI","WY","DC"
];
